import { render, staticRenderFns } from "./ProductCart.vue?vue&type=template&id=0b87882e&scoped=true&"
import script from "./ProductCart.vue?vue&type=script&lang=js&"
export * from "./ProductCart.vue?vue&type=script&lang=js&"
import style0 from "./ProductCart.vue?vue&type=style&index=0&id=0b87882e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87882e",
  null
  
)

export default component.exports